export const blacklist = {
  blacklistedUsers: "ผู้ใช้ที่ถูก Blacklist",
  type: "ประเภท",
  value: "ชื่อหรือเลขบัญชี",
  reason: "เหตุผล",
  createdBy: "ผู้สร้าง",
  createdAt: "วันที่สร้าง",
  createBlacklistUser: "สร้าง Blacklist",
  unlock: "Unlock",
  reset: "Reset",
  delete: "ลบข้อมูล",
  close: "ปิด",
  submit: "สร้าง",
  advanceFilter: "Advance Filter",
  createByCMS: '"Create By CMS" filter',
};
